import { useTranslation } from 'next-i18next';
import React from 'react';

const SupportGetInTouch = () => {
  const { t } = useTranslation('support');

  return (
    <p className="py-4 text-neutral-4">
      {t('stillLooking')}&nbsp;
      <a className="hyperlink" href="mailto:info@avantarte.com">
        {t('getInTouch')}
      </a>
    </p>
  );
};

export default SupportGetInTouch;
